var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      widthClass: "max-1000",
      title: _vm.$t("label_essweb_Announcement_form_newTitle"),
      initData: _vm.announcementData,
      backgroundClass: "white",
      checkData: [
        "message_title",
        "message_content",
        "send_org_level_uuid",
        "send_end_utc_datetime",
        "send_start_utc_datetime",
      ],
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  { attrs: { align: "center", justify: "start" } },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            maxlength: "200",
                            label: _vm.$t(
                              "label_essweb_Announcement_form_announcementTitleLabel"
                            ),
                          },
                          model: {
                            value: _vm.announcementData.message_title,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.announcementData,
                                "message_title",
                                $$v
                              )
                            },
                            expression: "announcementData.message_title",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            isRequire: "",
                            type: "datetimerange",
                            value: _vm.dateTerminal,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            defaultStartTime:
                              _vm.announcementData.send_start_utc_datetime,
                            defaultEndTime:
                              _vm.announcementData.send_end_utc_datetime,
                            label: _vm.$t(
                              "label_essweb_Announcement_form_publicTimeLabel"
                            ),
                          },
                          on: {
                            change: function (time, isre) {
                              _vm.dateTerminal = time
                              if (isre) {
                                _vm.announcementData.send_start_utc_datetime =
                                  time ? time.split(" - ")[0] : ""
                                _vm.announcementData.send_end_utc_datetime =
                                  time ? time.split(" - ")[1] : ""
                              }
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_Announcement_form_orgLeaveLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-combobox", {
                          attrs: {
                            items: [],
                            multiple: "",
                            "item-color": "transparent",
                            "small-chips": "",
                            rules: _vm.$GetRules(["_Require_ArrRules"], [null]),
                            filled: "",
                            dense: "",
                            "single-line": "",
                          },
                          on: {
                            "update:search-input": function (e) {
                              _vm.search = e
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  data.index < _vm.$selectSetting.maxChips
                                    ? _c(
                                        "v-chip",
                                        _vm._b(
                                          {
                                            staticClass: "mx-1 my-1",
                                            attrs: {
                                              close: "",
                                              "input-value": data.selected,
                                            },
                                            on: {
                                              click: data.select,
                                              "click:close": function ($event) {
                                                return _vm.removeOrg(data.item)
                                              },
                                            },
                                          },
                                          "v-chip",
                                          data.attrs,
                                          false
                                        ),
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  data.item.org_level_name
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  data.index === _vm.$selectSetting.maxChips
                                    ? _c(
                                        "span",
                                        { staticClass: "text--primary py-2" },
                                        [
                                          _vm._v(
                                            " ..." +
                                              _vm._s(
                                                _vm.announcementData
                                                  .send_org_level_uuid.length -
                                                  _vm.$selectSetting.maxChips
                                              ) +
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_selection_moreItemLabel"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "no-data",
                              fn: function () {
                                return [
                                  _vm.orgData.length == 0
                                    ? _c("noContent")
                                    : _c("v-treeview", {
                                        attrs: {
                                          selectable: "",
                                          "open-all": "",
                                          "open-on-click": "",
                                          "selected-color": "primary",
                                          search: _vm.search,
                                          filter: _vm.filter,
                                          items: _vm.orgData,
                                          "item-key": "uuid",
                                          "return-object": "",
                                          "item-text": "org_level_name",
                                          "item-children": "son_org",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "label",
                                            fn: function (ref) {
                                              var item = ref.item
                                              return [
                                                _c("span", {
                                                  staticClass:
                                                    "text--secondary",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.hightLightKeyword(
                                                        item.org_level_name,
                                                        _vm.search
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                        model: {
                                          value:
                                            _vm.announcementData
                                              .send_org_level_uuid,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.announcementData,
                                              "send_org_level_uuid",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "announcementData.send_org_level_uuid",
                                        },
                                      }),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.announcementData.send_org_level_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.announcementData,
                                "send_org_level_uuid",
                                $$v
                              )
                            },
                            expression: "announcementData.send_org_level_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "mb-0 pb-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_Announcement_form_contentLabel"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            "no-resize": "",
                            maxlength: "500",
                            dense: "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            counter: "500",
                            "single-line": "",
                            filled: "",
                          },
                          model: {
                            value: _vm.announcementData.message_content,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.announcementData,
                                "message_content",
                                $$v
                              )
                            },
                            expression: "announcementData.message_content",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "pt-0 mt-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-checkbox", {
                          attrs: {
                            label: _vm.$t(
                              "label_essweb_Announcement_form_confirmReadLabel"
                            ),
                            required: "",
                          },
                          model: {
                            value: _vm.announcementData.is_confirm_read,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.announcementData,
                                "is_confirm_read",
                                $$v
                              )
                            },
                            expression: "announcementData.is_confirm_read",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: {
                new: _vm.toAdd,
                cancel: function ($event) {
                  return _vm.$toBack(_vm.isChanged)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }